<template>
  <li :class="['cell pros-cell', extraClasses]">
    <ProsCollection
      :recommendation-config="recommendationConfig"
      :panel-config="panelConfig"
      @data-load-status-event="(isDataLoaded) => handleDataLoadStatus(isDataLoaded)"
    />
  </li>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import { ref, computed, defineAsyncComponent } from 'vue';

const ProsCollection = defineAsyncComponent(() => import('@common-vue/pros-collection/src/components/ProsCollection'));

const props = defineProps({
  recommendationConfig: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  panelConfig: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  options: {
    type: Object,
    required: false,
    default: () => ({}),
  },
});

const emptyRecommendations = ref(false);
const handleDataLoadStatus = (isDataLoaded) => {
  /* istanbul ignore else */
  if (!isDataLoaded) {
    emptyRecommendations.value = true;
    /* eslint-disable no-console */
    console.log(`MLT data failed to load for a product with the id of ${props.recommendationConfig.productId}`);
  }
};

const extraClasses = computed(() => ({
  'empty-recommendations': emptyRecommendations.value,
  'pros-cell-border': props.options.hasBorder,
  'extra-paddings': props.options.extraPaddings,
}));
</script>

<style lang="scss" scoped>
  .cell.pros-cell {
    width: calc(100% - 1.5rem) !important; // ro prevent override from global styles for .cell

    &:not(.empty-recommendations) {
      padding: 1rem 0 0;
    }

    &:not(.empty-recommendations):not(.extra-paddings) {
      margin: 0.75rem 0.75rem 1.5rem;

      @include breakpoint(medium down) {
        margin: 0.75rem 0.75rem 1rem;
      }
    }

    &:not(.empty-recommendations).extra-paddings {
      margin: 2.5rem 0.75rem 1.5rem;

      @include breakpoint(medium down) {
        margin: 2rem 0.75rem 1rem;
      }
    }
    &.empty-recommendations {
      margin: 0;
    }
    &.pros-cell-border:not(.empty-recommendations) {
      border-top: 1px solid $gray-3-color;
    }
  }
</style>
